/** *************************************************************
 * Copyright (c) 2006 - 2021, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 10/02/2019
 *
 * @version 0.2
 * Revisions:
 * 10/02/2019 - BW - Initial Creation
 * 11/25/2021 - BW - Added: _$privacyPolicyClass and events
 *
 * Description/Purpose:
 * Footer JS
 ************************************************************** */

import ModalUtil from "util/modal-util";
import PUBSUB_EVENT from "constant/pubsub-event";
import PubSub from 'pubsub-js';
import CommonUtil from "../util/common-util";


const Footer = {
  _$termsOfUseId: $('#terms_of_use'),
  _$privacyPolicyId: $('#privacy_policy'),
  _$remoteSupportId: $('#remote_support'),

  init() {
    this._registerEvent();
  },

  // Register events or DOM event
  _registerEvent() {
    PubSub.subscribe(PUBSUB_EVENT.FOOTER_TERMS_OF_USE_MODAL_OPEN_SUCCESS,
      this._footerTermsOfUseModalOpenSuccess.bind(this));
    this._$termsOfUseId
      .off('click')
      .on('click',
        ($event) => this._onTermsOfUseClick($event));
    $('.privacy-policy')
      .off('click')
      .on('click',
        ($event) => this._onPrivacyPolicyClick($event));
    // this._$termsOfUseId.click((event) => { this._onTermsOfUseClick(event); });
    // this._$privacyPolicyId.click((event) => { this._onPrivacyPolicyClick(event); });
  },


  /**
   * Just re-registers the events
   * @private
   */
  _footerTermsOfUseModalOpenSuccess() {
    debugger;
    this._registerEvent();
  },

  // Terms Of Use Click Handler
  _onTermsOfUseClick($event) {
    ModalUtil.showCustomDisplayWindowModal($event, this._$termsOfUseId, 'terms-of-use-modal',
      false, null, false, null, true,
      PUBSUB_EVENT.FOOTER_TERMS_OF_USE_MODAL_OPEN_SUCCESS);
  },

  // Privacy Policy Click Handler
  _onPrivacyPolicyClick($event) {
    ModalUtil.showCustomDisplayWindowModal($event, this._$privacyPolicyId, 'privacy-policy-modal',
      false);
  },

};
export default Footer;
